var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redes-view"},[_c('NavbarWorld'),_c('NoticiaWorld'),_c('BlogNoticia'),_c('router-link',{ref:"backBtn",staticClass:"service-detail__back fade-in",attrs:{"to":"/"}},[_vm._v(" ← Volver al inicio ")]),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }